import { useAuthStore } from "presentation/stores/use-auth-store";
import logo from "../../../assets/logo.svg";
import { clearLocalStorage } from "presentation/utils/localStorage";
import { Menu } from "primereact/menu";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useNavigationStore } from "presentation/mobile/stores/navigation-store";
import { useRolesStore } from "presentation/stores/use-roles-list-store";
import { useImpersonationStore } from "presentation/stores/use-impersonation-store";
import ImpersonateDialog from "presentation/components/Header/MenuProfile/ImpersonateDialog";
import { Button } from "primereact/button";
const MobileAppBar = () => {
    const { clearAuth, userName, userEmployee, userPermissions } = useAuthStore();
    const navigate = useNavigate();
    const {currentRoute, routes, setCurrentRoute, setUseSubMenu, currentSubRoutes, setCurrentSubRoutes} = useNavigationStore();
    const [impersonateDialogVisible, setImpersonateDialogVisible] = useState(false);

    const { isDebugMode, originalEmployee, disableImpersonation } = useImpersonationStore();
    const { roles } = useRolesStore();

    const hasDeveloperRole = roles?.some((r: any) => r.name === "Developer") || 
                           userPermissions?.some((p: any) => p.role?.name === "Developer" || p.function?.name === "Developer");
    const isDeveloper = hasDeveloperRole && !isDebugMode;
    
    const menu = useRef<Menu>(null);
    
    const items: any[] = [
        {
            label: "Sair",
            icon: "pi pi-power-off",
            command: () => {
                clearAuth();
                clearLocalStorage();
                navigate("/login");
            }
        },
    ]

    if (isDeveloper && !isDebugMode) {
        items.push({
        label: "Ver como...",
        icon: "pi pi-users",
        command: () => {
            setImpersonateDialogVisible(true);
        }
        });
    }

    const handleBack = () => {
        if
        (currentSubRoutes.length > 1) {
            setUseSubMenu(true);
            navigate("/mobile");
            return;
        }

        setUseSubMenu(false);
        setCurrentSubRoutes([]);

        if(window.history.length > 1){
            navigate(-1);
        }else {
            setCurrentRoute("home");
            navigate("/mobile");
        }
    };

    const handleDisableDebug = () => {
        disableImpersonation();
        window.location.reload();
    };

    const getInitials = (userFullName?: string | null) => {
        if (!userFullName) return "U";
        const parts = userFullName.trim().split(" ");
        if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    };


    const getLabel = () => {
        const notFoundLabel = "(?)";
        const routeWithName = routes.find((route) => route.name === currentRoute)
        if(routeWithName)
            return routeWithName.label;

        let subRouteLabel: string | null = null
        routes.forEach((route) => { 
                route.subRoutes?.forEach((subRoute) => {
                    if(subRoute.name === currentRoute){
                        subRouteLabel = subRoute.label
                        return;
                    }
                })
                if(subRouteLabel)
                    return;
            }
        )

        if(subRouteLabel)
            return subRouteLabel;

        return notFoundLabel;
    }
    const getLeftItem = () => {
        if(currentRoute === "" || currentRoute === "home"){
            return (
                <img src={logo} alt="Logo" style={{ width: '125px', height: 'auto' }} />
            )
        }
        return (
            <div className="flex flex-row align-items-center justify-content-center gap-3">
                <div 
                role="button" 
                className="cursor-pointer"
                onClick={() => handleBack()}
                >
                    <i className="pi pi-arrow-left text-lg" style={{ color: "#0663c7" }}></i>
                </div>
                <span className="text-xl mb-1">{getLabel()}</span>
            </div>
        );
    }

    return (
        <>
        <div 
        className="flex flex-row w-full justify-content-between align-items-center px-4 border-bottom-1 pb-3"
        style={{ borderColor: "#a7a7a7ad", backgroundColor: "#ffffff", paddingTop:"max(0.75rem, env(safe-area-inset-top))"}}
        >
            {getLeftItem()}
            <div className="flex gap-2 align-items-center">
                {isDebugMode && (
                    <div className="border-circle" style={{
                        backgroundColor: '#ff9800',
                        color: 'white',
                        padding: '6px 2px',
                        display: 'flex',
                        alignItems: 'center',
                        fontWeight: 'bold',
                        borderRadius: '8px',
                        fontSize: '12px',
                        gap: '8px',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.2)'
                    }}>
                        <Button 
                        icon="pi pi-power-off" 
                        onClick={handleDisableDebug} 
                        className="p-button-danger p-button-sm p-button-text" 
                        style={{color: '#fff', width: '15px', height: '20px' }} 
                        title={`Desligar Simulação (Original: ${originalEmployee?.name || 'Developer'})`}
                        size="small"
                        />
                    </div>
                )}
                <div 
                onClick={(event) => menu.current?.toggle(event)} 
                className="w-2rem h-2rem border-circle flex align-items-center justify-content-center text-sm shadow-2 cursor-pointer"
                    style={{ backgroundColor: "#2c92ff" }}>
                    <span>{getInitials(userEmployee?.name || userName)}</span>
                </div>
                
            </div>
        </div>
        <Menu model={items} popup ref={menu} id="popup_menu" />
        <ImpersonateDialog 
            visible={impersonateDialogVisible} 
            onHide={() => setImpersonateDialogVisible(false)} 
        />
        </>
    )
}

export default MobileAppBar;